module.exports = __webpack_public_path__ + "static/media/team_4.da4547bd.png";